import React from 'react'
import fig from "./ZKZg.gif" 
import "./Loading.css"
const Loading = () => {
  return (
    <div>
        <img ID="OKO"src={fig} alt="Loading..."/>
    </div>
  )
}

export default Loading